<script>
export default {
    name: "BaseMasterCardIcon"
}
</script>

<template>
    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.6503 3.74609H12.5151V20.2539H21.6503V3.74609Z" fill="#FF5A00"/>
        <path d="M13.1232 12C13.1232 8.64612 14.6907 5.66942 17.0962 3.74612C15.3259 2.34612 13.0928 1.5 10.657 1.5C4.88669 1.5 0.217773 6.19612 0.217773 12C0.217773 17.8039 4.88669 22.5 10.657 22.5C13.0928 22.5 15.3259 21.6539 17.0962 20.2539C14.6874 18.3578 13.1232 15.3539 13.1232 12Z" fill="#EB001B"/>
        <path d="M33.9744 12C33.9744 17.8039 29.3055 22.5 23.5353 22.5C21.0994 22.5 18.8663 21.6539 17.0961 20.2539C19.5319 18.3272 21.069 15.3539 21.069 12C21.069 8.64612 19.5015 5.66942 17.0961 3.74612C18.863 2.34612 21.0961 1.5 23.5319 1.5C29.3055 1.5 33.9744 6.2267 33.9744 12Z" fill="#F79E1B"/>
    </svg>
</template>

<style scoped>

</style>
